export const IMAGES = {
  heroToronto:
    "https://images.unsplash.com/photo-1586576782138-19304c43d0e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHx0b3JvbnRvJTIwYXJjaGl0ZWN0dXJlJTIwYWJzdHJhY3R8ZW58MHx8fHwxNzg4MDY0MTU2fDA&ixlib=rb-4.1.0&q=85",
  boardroom:
    "https://images.unsplash.com/photo-1517502884422-41eaead166d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBib2FyZHJvb20lMjBuYXR1cmFsJTIwbGlnaHR8ZW58MHx8fHwxNzg4MDY0MTU2fDA&ixlib=rb-4.1.0&q=85",
  mosaicTexture:
    "https://images.unsplash.com/photo-1573504816327-07f3bf7accac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMG1vc2FpYyUyMHRleHR1cmV8ZW58MHx8fHwxNzg4MDY0MTU2fDA&ixlib=rb-4.1.0&q=85",
  podium:
    "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  forum:
    "https://images.unsplash.com/photo-1540575467063-178a50c2df87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const EXPERTISE = [
  {
    title: "Strategic Communications",
    copy: "Strategic counsel that connects communications with business, organizational, public affairs or reputational objectives.",
  },
  {
    title: "Media Relations & Public Relations",
    copy: "Helping organizations tell credible stories, strengthen their public profile and develop productive relationships with media.",
  },
  {
    title: "Public Affairs & Government Relations",
    copy: "Helping clients understand government, policy and public-sector environments while developing effective engagement and communications strategies.",
  },
  {
    title: "Stakeholder & Community Engagement",
    copy: "Identifying key stakeholders, building relationships, facilitating dialogue and helping organizations earn community trust.",
  },
  {
    title: "Multicultural Communications",
    copy: "Connecting organizations authentically with Toronto and Canada's diverse cultural communities through culturally informed outreach, communications and engagement.",
  },
  {
    title: "Reputation, Issues & Crisis Communications",
    copy: "Helping clients prepare for, respond to and communicate through sensitive, complex or rapidly developing situations.",
  },
  {
    title: "Political Consulting",
    copy: "Strategic campaign counsel, communications, candidate positioning, stakeholder engagement, media strategy, community outreach and campaign execution.",
  },
  {
    title: "Project Management & Events",
    copy: "Strategic planning and execution of corporate, community, public affairs, media and stakeholder events and initiatives.",
  },
];

export const WHY_MOSAICON = [
  {
    title: "Senior-Level Attention",
    copy: "Clients work directly with experienced consultants rather than being passed through multiple layers of account management.",
  },
  {
    title: "Cultural Intelligence",
    copy: "We understand the communities, languages, relationships and cultural nuances that shape the Greater Toronto Area.",
  },
  {
    title: "Integrated Thinking",
    copy: "Communications, media, community engagement, government relations and reputation rarely operate independently. We connect them.",
  },
  {
    title: "Strategy + Execution",
    copy: "We do more than write plans. We help clients put them into action.",
  },
];

export const METHODOLOGY = [
  { title: "Listen", copy: "Understand the client's objectives, challenges and environment." },
  { title: "Understand", copy: "Identify audiences, stakeholders, opportunities, risks and the communications landscape." },
  { title: "Strategize", copy: "Develop the positioning, messages, relationships and tactics required to achieve the objective." },
  { title: "Connect", copy: "Reach the appropriate media, government, communities, stakeholders and audiences." },
  { title: "Deliver", copy: "Execute effectively, monitor results and adapt strategy as circumstances evolve." },
];

export const AUDIENCES = [
  "Businesses and corporations",
  "Entrepreneurs and business leaders",
  "Professional services firms",
  "Non-profit and charitable organizations",
  "Community organizations",
  "Associations",
  "Cultural organizations",
  "Public institutions",
  "Political candidates and campaigns",
  "Public figures and community leaders",
];

export const SERVICES = [
  {
    title: "Media Relations & Strategic Communications",
    intro: "Mosaicon helps clients develop messages that are clear, credible and relevant to the audiences they need to reach.",
    services: [
      "Communications strategy", "Messaging development", "Media strategy", "Media outreach",
      "Press releases", "Media advisories", "Speeches", "Talking points",
      "Executive communications", "Media monitoring", "Communications planning",
      "Corporate positioning", "Strategic copywriting",
    ],
  },
  {
    title: "Public Relations & Corporate Communications",
    intro: "Help organizations strengthen their public positioning and communicate effectively with employees, partners, customers, media, communities and other external audiences.",
    services: [
      "Corporate narratives", "Announcements", "Launches", "Executive profiles",
      "Organizational communications", "Reputation-building initiatives", "Communications campaigns",
    ],
  },
  {
    title: "Public Affairs & Government Relations",
    intro: "Organizations increasingly operate at the intersection of business, government, policy and public opinion. Mosaicon helps clients better understand this environment and develop thoughtful approaches to government and public-sector engagement.",
    services: [
      "Government and policy landscape analysis", "Stakeholder mapping", "Government engagement strategies",
      "Briefing materials", "Meeting preparation", "Advocacy communications",
      "Relationship development", "Public affairs strategy",
    ],
    note: "Engagements are conducted in accordance with applicable Canadian and Ontario laws, regulations and lobbying-registration requirements.",
  },
  {
    title: "Stakeholder Relations & Community Engagement",
    intro: "Successful initiatives often depend upon earning the understanding and support of people outside an organization. We identify relevant stakeholders, understand their interests and concerns and create engagement strategies designed to build productive relationships.",
    services: [
      "Stakeholder mapping", "Community outreach", "Consultation strategy", "Partnership development",
      "Roundtables", "Community meetings", "Stakeholder communications", "Relationship management",
      "Community event activation",
    ],
  },
  {
    title: "Multicultural Marketing & Community Outreach",
    intro: "Toronto is one of the world's most culturally diverse metropolitan regions. Reaching diverse communities effectively requires much more than translation. It requires cultural understanding, trusted relationships, appropriate messengers, relevant communications channels and an understanding of how individual communities receive and share information. Mosaicon helps organizations develop culturally informed outreach strategies that create authentic connections.",
    services: [
      "Multicultural communications strategy", "Community partnerships", "Ethnic media relations",
      "Cultural event engagement", "Community leader outreach", "Localized messaging",
      "Multilingual campaign coordination", "Culturally relevant communications",
    ],
    note: "Translation services are coordinated through trusted specialist partners where required.",
  },
  {
    title: "Reputation Management, Issues & Crisis Communications",
    intro: "Reputation can take years to build and moments to put at risk. Mosaicon works with clients to anticipate communications challenges, prepare for emerging issues and respond effectively when difficult situations arise.",
    services: [
      "Risk assessment", "Scenario planning", "Crisis communications protocols", "Holding statements",
      "Media response", "Stakeholder communications", "Executive briefing", "Issues monitoring",
      "Post-incident reputation recovery",
    ],
  },
  {
    title: "Digital Communications & Advocacy",
    intro: "Digital platforms have transformed how organizations build communities, influence conversations and manage reputation. We help clients connect digital communications to broader communications and public affairs objectives.",
    services: [
      "Digital strategy", "Content planning", "Social media communications", "Digital campaigns",
      "Online reputation strategy", "Audience engagement", "Website content", "Digital advocacy strategy",
    ],
    note: "Where specialized technical execution such as web development, advanced SEO or paid advertising is required, Mosaicon may work with specialist partners.",
  },
  {
    title: "Strategic Copywriting & Content",
    intro: "Strong strategy requires strong language. Mosaicon develops clear, persuasive and audience-appropriate written communications.",
    services: [
      "Corporate profiles", "Speeches", "Presentations", "Websites", "Brochures",
      "Public statements", "Newsletters", "Campaign literature", "Stakeholder materials",
      "Executive communications",
    ],
  },
  {
    title: "Project Management & Event Planning",
    intro: "Mosaicon can manage strategic initiatives from concept through execution — planning, stakeholder coordination, communications, logistics and execution.",
    services: [
      "Stakeholder events", "Press conferences", "Community events", "Networking events",
      "Public forums", "Launches", "Conferences", "Receptions", "Fundraising events",
      "Roundtables", "Special projects",
    ],
  },
];

export const POLITICAL_AREAS = [
  {
    title: "Campaign Strategy",
    copy: "Strategic planning from pre-campaign preparation through election day, including campaign positioning, priorities, timelines, organizational planning and campaign execution.",
  },
  {
    title: "Candidate Positioning & Messaging",
    copy: "Developing an authentic candidate narrative, key messages, campaign themes, speeches, talking points and communications that clearly explain who the candidate is, what they stand for and why they are seeking public office.",
  },
  {
    title: "Media & Communications",
    copy: "Media strategy, press releases, media advisories, interview preparation, announcements, rapid-response communications, speechwriting and media relations.",
  },
  {
    title: "Stakeholder & Community Outreach",
    copy: "Identifying important community organizations, business leaders, neighbourhood organizations and other stakeholders and developing meaningful engagement strategies.",
  },
  {
    title: "Multicultural Campaign Outreach",
    copy: "Helping campaigns understand and communicate authentically with the GTA's diverse communities through culturally informed communications, community relationships, ethnic media and appropriate outreach channels.",
  },
  {
    title: "Campaign Events",
    copy: "Planning and coordinating campaign launches, fundraising events, community meetings, rallies, media events, roundtables and other campaign activities.",
  },
  {
    title: "Campaign Communications Materials",
    copy: "Strategic direction and copywriting for websites, candidate biographies, brochures, direct communications, newsletters, fundraising communications, digital content and other campaign materials.",
  },
  {
    title: "Debate & Media Preparation",
    copy: "Message preparation, anticipated questions, interview preparation, speaking points and strategic communications coaching.",
  },
];

export const INSIGHT_CATEGORIES = [
  "Strategic Communications",
  "Media Relations",
  "Public Affairs",
  "Community Engagement",
  "Multicultural Communications",
  "Political Campaigns",
  "Reputation & Issues",
];

export const CONTACT_AREAS = [
  "Strategic Communications",
  "Media Relations / Public Relations",
  "Public Affairs / Government Relations",
  "Stakeholder & Community Engagement",
  "Multicultural Communications",
  "Reputation / Issues / Crisis",
  "Political Consulting",
  "Project Management / Events",
  "Other",
];
